import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_my_grid = _resolveComponent("my-grid")!

  return (_openBlock(), _createBlock(_component_my_grid, {
    data: _ctx.confItems,
    sortable: false,
    reorderable: false,
    columns: _ctx.columns
  }, {
    customTemplate1: _withCtx(({props}) => [
      (props.dataItem.propertyValues.length == 1)
        ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(props.dataItem.propertyValues[0]), 1))
        : (_openBlock(), _createElementBlock("ul", _hoisted_2, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.dataItem.propertyValues, (value) => {
              return (_openBlock(), _createElementBlock("li", { key: value }, _toDisplayString(value), 1))
            }), 128))
          ]))
    ]),
    _: 1
  }, 8, ["data", "columns"]))
}